// Service for generating fun display usernames from a student's favourites
import { getApiUrl } from './apiConfig';

export const suggestDisplayUsernames = async ({ animal, snack, pastime }) => {
  const response = await fetch(getApiUrl('student-profile/suggest-username'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ animal, snack, pastime })
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || 'Could not create fun names right now. Please try again.');
  }
  return data.suggestions || [];
};
